import { Action, FiltersState } from "./types";

const FiltersReducer = (state: FiltersState, action: Action) => {
    switch (action.type) {
        case "SET_DAY_FROM":
            return { ...state, dayFrom: action.payload };
        case "SET_DAY_TO":
            return { ...state, dayTo: action.payload };
        default:
            return state;
    }
}

export default FiltersReducer;